"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeUserRole = void 0;
exports.IkeUserRole = {
    USER: 'user',
    ROOT: 'root',
    EDITOR: 'editor',
    VIEWER: 'viewer',
    DOWNLOADER: 'downloader',
    DATA_ADMIN: 'data-admin',
    /**
     * User has no permissions for this department
     */
    NONE: 'none'
};
//# sourceMappingURL=role.js.map